import type { FaireProductEntity } from "../../entity_types/product";

export const p_d4knxmza9r: FaireProductEntity = {
  token: "p_d4knxmza9r",
  type: "product",
  name: "12PCS - Pocket Hand Sanitizer Spray",
  brandToken: "b_c3xmn96nkh",
  brandName: "Sensibling Corp.",
  imageUrl:
    "https://cdn.faire.com/fastly/8ee8206df8a6e75fe11551409685915a4a4880866614a80f48a429d6ed80e943.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0cf0947c241c2d0bd8458fb2d2b07f3db2bf1414fe06e384ae03a2ff222468c1.jpeg",
    "https://cdn.faire.com/fastly/37600d06fd91583c9735a77e1a35935d0152266fb0aa75f2cb43241aa15f29da.jpeg",
    "https://cdn.faire.com/fastly/d27407c0ba3e7c1767ce14eb83be1301e9550f0a0874b99a1eecdf006fc7c2cd.jpeg",
  ],
  priceDollars: 2.07,
  description:
    '• Size : 2.25" X 4" X 0.7"\n• A compact hand sanitizer spray card set designed for easy on-the-go hygiene. Slim, portable format fits pockets or bags, ideal for travel, school, events, party favors, or daily use, offering quick refresh and convenient sharing anytime, anywhere.',
  tags: [],
  msrpDollars: 4.14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:40.373Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
